import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SESSION_VAR_KEY_LANGUAGE, DEFAULT_LANGUAGE, SPECIAL_CASE_MARKET_LANGUAGE_MAP, SESSION_VAR_KEY_MARKET, DEFAULT_MARKET } from '@ibe.config';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';

@Component({
  selector: 'app-site-is-down',
  templateUrl: './site-is-down.indra.component.html',
  styleUrls: ['./site-is-down.component.scss']
})
export class INDRASiteIsDownComponent implements OnInit {

  constructor(
    private router: Router,
    private ibeAdminConfigService: INDRAIbeAdminConfigService,

  ) { }

  ngOnInit() {
  }

  INDRA_openLink(key) {
    const languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
                            sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
    const languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
    const marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
                            sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
    const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
    const urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`);
    return window.open(urlNavigate);
  }


}
